"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processAnalysis = void 0;
function processAnalysis(resp) {
    resp.data.result = resp.data.result.map((attributes) => {
        attributes.vetroId = attributes.vetro_id;
        delete attributes.vetro_id;
        return attributes;
    });
}
exports.processAnalysis = processAnalysis;
//# sourceMappingURL=analysis.js.map